module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-from-top-38d6fe80034b6ff79bdaee75194a986e.svg";